import { UserData } from '../app/api/user/types';

type StoragesKey = 'localStorage' | 'sessionStorage';

const Storages = {
  localStorage,
  sessionStorage,
};

interface PersistentStorage {
  setItem(key: string, value: unknown, storage?: StoragesKey): void;
  getItem<T = string>(key: string, storage?: StoragesKey): T | null;
  deleteItem(key: string, storage?: StoragesKey): void;
  deleteAll(storage?: StoragesKey): void;
}

export const storage: PersistentStorage = {
  setItem: (key: string, value: unknown, storage: StoragesKey = 'localStorage') => {
    if (value === undefined) {
      Storages[storage].removeItem(key);
    } else {
      Storages[storage].setItem(key, JSON.stringify(value));
    }
  },
  getItem: <T>(key: string, storage: StoragesKey = 'localStorage'): T | null => {
    const item = Storages[storage].getItem(key);

    if (item === null) return null;

    if (item === 'null') return null;
    if (item === 'undefined') return null;

    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(item);
      // eslint-disable-next-line no-empty
    } catch {}

    return item as T;
  },
  deleteItem: (key: string, storage: StoragesKey = 'localStorage') => {
    Storages[storage].removeItem(key);
  },
  deleteAll: (storage: StoragesKey = 'localStorage') => Storages[storage].clear(),
};

export const updateSessionToken = (token: string): void => {
  storage.setItem('token', token);
};

export const updateSession = (activeUser: UserData | null): void => {
  storage.setItem('userRole', activeUser?.kind);
  storage.setItem('userId', activeUser?.id, 'sessionStorage');
};

export const removeSession = (): void => {
  const loginPath = getLoginPath();
  storage.deleteAll();
  storage.deleteAll('sessionStorage');
  if (loginPath) {
    setLoginPath(loginPath);
  }
};

export const getAccessInfo = (key: string): string | null => storage.getItem(key);

export const getActiveUserId = (): number | null => {
  return storage.getItem<number | null>('userId', 'sessionStorage');
};

export const setSendbirdUserId = (userId: string) => {
  storage.setItem('sendbirdUserId', userId);
};

export const setSendbirdToken = (token: string) => {
  storage.setItem('sendbirdToken', token);
};

export const clearSendbirdConfig = () => {
  storage.deleteItem('sendbirdUserId');
  storage.deleteItem('sendbirdToken');
};

const LOGIN_PATH_KEY = 'loginPath';
export const getLoginPath = (): string | null => {
  return storage.getItem<string | null>(LOGIN_PATH_KEY);
};

export const setLoginPath = (path: string) => {
  storage.setItem(LOGIN_PATH_KEY, path);
};

export const clearLoginPath = () => {
  storage.deleteItem(LOGIN_PATH_KEY);
};
